<template>
  <v-card light outlined :class="$store.state.isMobile ? 'mx-0' : 'mx-3'">
    <v-card-text>
      <v-row no-gutters justify="center" align="center">
        <v-col cols="12" sm="8">
          <v-select
            light
            :menu-props="{ bottom: true, offsetY: true }"
            v-model="in_mode_selected"
            :items="modes"
            @change="mode_set()"
          >
            <template v-slot:label>
              <v-icon size="22" class="mx-1" color="black"
                >mdi-robot-happy</v-icon
              >
              {{ $t("messanger.dash.filters.Bot_Human_mode.modes") }}
            </template>
            <template slot="selection" slot-scope="{ item }">
              {{ $t(`messanger.dash.filters.Bot_Human_mode.${item.text}`) }}
            </template>
            <template v-slot:item="{ item }">
              {{ $t(`messanger.dash.filters.Bot_Human_mode.${item.text}`) }}
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider class="ma-0 pa-0"></v-divider>
    <v-card-text>
      <v-row dnese no-gutters justify="center" align="center">
        <v-col cols="12" sm="6">
          <v-menu
            ref="menu3"
            v-model="picker.menu3"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="picker.time3"
            transition="scale-transition"
            offset-y
            max-width="300px"
            min-width="300px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="picker.time3"
                :label="$t('messanger.dash.filters.Bot_Human_mode.start')"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="picker.menu3"
              v-model="picker.time3"
              full-width
              @click:minute="$refs.menu3.save(picker.time3)"
              color="primary"
            >
            </v-time-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6">
          <v-menu
            ref="menu4"
            v-model="picker.menu4"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="picker.time4"
            transition="scale-transition"
            offset-y
            max-width="300px"
            min-width="300px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="picker.time4"
                :label="$t('messanger.dash.filters.Bot_Human_mode.end')"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="picker.menu4"
              v-model="picker.time4"
              full-width
              @click:minute="$refs.menu4.save(picker.time4)"
              color="primary"
            >
            </v-time-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6">
          <v-menu
            ref="menu1"
            v-model="picker.menu1"
            :close-on-content-click="false"
            :return-value.sync="picker.time1"
            transition="scale-transition"
            offset-y
            max-width="300px"
            min-width="300px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="picker.time1"
                :label="$t('messanger.dash.filters.Bot_Human_mode.lunch_start')"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="picker.menu1"
              v-model="picker.time1"
              full-width
              @click:minute="$refs.menu1.save(picker.time1)"
              color="primary"
            ></v-time-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6">
          <v-menu
            ref="menu2"
            v-model="picker.menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="picker.time2"
            transition="scale-transition"
            offset-y
            max-width="300px"
            min-width="300px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="picker.time2"
                :label="$t('messanger.dash.filters.Bot_Human_mode.lunch_end')"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="picker.menu2"
              v-model="picker.time2"
              full-width
              @click:minute="$refs.menu2.save(picker.time2)"
              color="primary"
            ></v-time-picker>
          </v-menu>
        </v-col>
        <v-col cols="12">
          <v-chip-group
            v-model="picker.days"
            column
            multiple
            active-class="purple--text"
          >
            <v-row dense no-gutters justify="center" align="center">
              <v-col
                cols="auto"
                v-for="(day, index) in daysOfWeek"
                :key="index"
              >
                <v-chip outlined>
                  {{ $t(`daysOfweek.${day}`) }}
                </v-chip>
              </v-col>
            </v-row>
          </v-chip-group>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary darken-1" @click="save()">
          <strong>{{ $t("store.update") }}</strong>
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "AutoModeDates",
  data() {
    return {
      in_mode_selected: null,
      modes: [
        { text: "human_mode", value: "human" },
        { text: "bot_mode", value: "bot" },
      ],
      picker: {
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        time1: null,
        time2: null,
        time3: null,
        time4: null,
        days: [],
      },
      daysOfWeek: [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ],
    };
  },
  computed: {
    config() {
      return this.$store.state.store_config.store.chat_config;
    },
  },
  mounted() {
    if (this.config.auto.time_configuration) {
      this.picker.time1 =
        this.config.auto.time_configuration.lunch_start || null;
      this.picker.time2 = this.config.auto.time_configuration.lunch_end || null;
      this.picker.time3 = this.config.auto.time_configuration.start || null;
      this.picker.time4 = this.config.auto.time_configuration.end || null;
      this.picker.days = this.config.auto.time_configuration.days || [];
    }
    if (this.config.auto) {
      this.in_mode_selected = this.config.auto.mode || null;
    }
  },
  methods: {
    mode_set() {
      const main_mode = this.config.selected_mode;
      const mode = this.in_mode_selected;
      console.log("main_mode:", main_mode, "in_mode : ", mode);
      // this.$store
      //   .dispatch("UPDATE_CONFIG_IN_MODE", { main_mode, mode })
      //   .then((r) => {
      //     this.$socket.emit("UPDATE_CHAT_CONFIG_SOCKET", this.config);
      //     this.$store.dispatch("setSnackbar", {
      //       showing: true,
      //       text: `Mode : ${this.in_mode_selected}`,
      //       color: "success",
      //       timeout: 1000,
      //     });
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    check_human_hours() {
      if (
        this.picker.time1 === null ||
        this.picker.time2 === null ||
        this.picker.time3 === null ||
        this.picker.time4 === null ||
        this.picker.days.length === 0 ||
        !this.in_mode_selected
      )
        return false;
      return true;
    },
    save() {
      if (!this.check_human_hours()) {
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: `${this.$t(
            "messanger.dash.filters.Bot_Human_mode.fill_error"
          )}`,
          color: "info",
          timeout: 2000,
        });
        return;
      } else {
        const time_configuration = {
          days: this.picker.days,
          end: this.picker.time4,
          start: this.picker.time3,
          lunch_end: this.picker.time2,
          lunch_start: this.picker.time1,
        };
        if (
          JSON.stringify(this.config.auto.time_configuration) !==
          JSON.stringify(time_configuration)
        ) {
          this.$store.dispatch("setLoader", {
            showing: true,
            text: "Updating ...",
          });
          this.$store
            .dispatch("UPDATE_AUTO_MODE", { time_configuration })
            .then((res) => {
              this.$store.dispatch("setLoader", {
                showing: false,
              });
              this.$socket.emit("UPDATE_CHAT_CONFIG_SOCKET", this.config);
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: "auto mode updated",
                color: "success",
                timeout: 1000,
              });
            })
            .catch((err) => {
              console.log(err);
              this.$store.dispatch("setLoader", {
                showing: false,
              });
            });
        } else {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text: this.$t(
              "messanger.dash.filters.Bot_Human_mode.times_no_change"
            ),
            color: "info",
            timeout: 2000,
          });
        }
      }
    },
  },
};
</script>
